import { render, staticRenderFns } from "./briefBoard.vue?vue&type=template&id=57c91387&scoped=true"
import script from "./briefBoard.vue?vue&type=script&lang=js"
export * from "./briefBoard.vue?vue&type=script&lang=js"
import style0 from "./briefBoard.vue?vue&type=style&index=0&id=57c91387&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c91387",
  null
  
)

export default component.exports